import type { Auth0Client, Auth0ClientOptions } from '@auth0/auth0-spa-js'

import { createAuth0Client } from '@auth0/auth0-spa-js'
import { buildPath } from '@rentspree/path'

import { AUTH_SESSION_TIMEOUT } from '../constant/auth'

export class AuthService {
  private auth0: Auth0Client | null = null

  async init(options: Auth0ClientOptions): Promise<void> {
    this.auth0 = await createAuth0Client(options)
  }

  async isAuthenticated(): Promise<boolean> {
    if (!this.auth0) {
      throw new Error('Auth service must be initialized')
    }
    return this.auth0.isAuthenticated()
  }

  async getAccessToken(): Promise<string | null> {
    if (!this.auth0) {
      throw new Error('Auth service must be initialized')
    }

    try {
      return await this.auth0.getTokenSilently()
    } catch (e) {
      this.redirectToSessionTimeout()
      return null
    }
  }

  async getEmail(): Promise<string> {
    if (!this.auth0) {
      throw new Error('Auth service must be initialized')
    }
    return (await this.auth0.getUser())?.email || ''
  }

  private redirectToSessionTimeout = () => {
    const queryString = { continue: window.location.href }
    const url = buildPath(`${window.location.origin}${AUTH_SESSION_TIMEOUT}`, undefined, {
      ...queryString,
    })
    window.location.replace(url)
  }
}

export const authService = new AuthService()
